const DOCUMENT_METADATA_IMPORT_CHANNEL = "thedmseffect-document-metadata-import";
const DOCUMENT_METADATA_IMPORTED = "document-metadata-imported";

const createChannel = () => {
  if (typeof window === "undefined" || typeof window.BroadcastChannel !== "function") {
    return null;
  }

  try {
    return new window.BroadcastChannel(DOCUMENT_METADATA_IMPORT_CHANNEL);
  } catch {
    return null;
  }
};

const closeChannel = (channel) => {
  try {
    channel.close();
  } catch {
    // Cross-tab refresh is best effort and must never change the import outcome.
  }
};

const normaliseSiteId = (siteId) => String(siteId ?? "").trim();

export const publishDocumentMetadataImported = (siteId) => {
  const normalisedSiteId = normaliseSiteId(siteId);
  if (!normalisedSiteId) {
    return false;
  }

  const channel = createChannel();
  if (!channel) {
    return false;
  }

  try {
    channel.postMessage({
      type: DOCUMENT_METADATA_IMPORTED,
      siteId: normalisedSiteId,
    });
    return true;
  } catch {
    return false;
  } finally {
    closeChannel(channel);
  }
};

export const subscribeToDocumentMetadataImported = (onImported) => {
  const channel = createChannel();
  if (!channel) {
    return () => {};
  }

  const handleMessage = (event) => {
    const message = event?.data;
    if (
      message?.type === DOCUMENT_METADATA_IMPORTED &&
      normaliseSiteId(message.siteId)
    ) {
      onImported(message);
    }
  };

  channel.addEventListener("message", handleMessage);

  return () => {
    channel.removeEventListener("message", handleMessage);
    closeChannel(channel);
  };
};

export const isDocumentMetadataImportForSite = (message, siteId) => {
  const currentSiteId = normaliseSiteId(siteId);
  return Boolean(currentSiteId) && normaliseSiteId(message?.siteId) === currentSiteId;
};
